const getEpiCartItems = () => { // getCartItems()
  const url = `${window.location.protocol}//${window.location.hostname}/api/v1/cart`;
  return new Promise((resolve, reject) => {
    fetch(url)
      .then(r => r.json())
      .then(resolve)
      .catch(reject);
  });
};

const addToEpiCart = code => ( // addToCart()
  new Promise((resolve, reject) => {
    fetch(`${window.location.protocol}//${window.location.hostname}/api/v1/cart/items/${code}`, {
      method: 'POST',
      headers: {
        accept: 'application/json',
        'content-type': 'application/json',
      },
    })
      .then((r) => {
        if (r.ok) {
          r.json().then(resolve);
        } else {
          r.json().then(reject);
        }
      })
      .catch(reject);
  })
);


const removeFromEpiCart = (code) => { // removeFromCart()
  const url = `${window.location.protocol}//${window.location.hostname}/api/v1/cart/items/${code}`;
  return new Promise((resolve, reject) => {
    fetch(url, { method: 'DELETE' })
      .then((r) => {
        if (r.ok) {
          resolve();
        } else {
          r.json().then(reject);
        }
      })
      .catch(reject);
  });
};

export {
  getEpiCartItems,
  addToEpiCart,
  removeFromEpiCart,
};
